<template>
  <section>
    <div data-aos="fade-up" :data-aos-delay="200">
      <section>
        <!--- start of courses list----------->
        <div class="row y-gap-30 side-content__wrap">
          <!------#3 course Element start ------------------>
          <div class="side-content col-xl-4 col-lg-6 col-md-4 col-sm-6 relative d-flex flex-column"
            v-for="item in courses" :key="item.uuid">
            <!-- Start of Course Card -->
            <div class="coursesCard -type-1 pb-10 border-light rounded-8" style="flex: 1">
              <router-link :to="{ name: 'single-course', params: { id: item.slug } }">
                <div class="relative">
                  <div class="coursesCard__image overflow-hidden rounded-8">
                    <div class="course-image-container">
                      <img class="w-1/1" :src="item?.preview_image" alt="image" />
                    </div>
                    <!-----Pricing Percent------->
                    <div class="d-inline-flex justify-content-center align-items-center x-gap-10 discount">
                      <span class="capitalize fw-400 best-seller"> {{ $t('expires_in') }} {{ item?.options['expire_in_months'] }} {{
                        $t('months') }}</span>
                      
                      <span v-if="item?.pricing.length !== 0" class="offer">
                    <span class="capitalize"
                      v-if="item?.pricing[0]?.original_price - item?.pricing[0]?.price !== 0 && !item?.pricing[0]?.price.is_free">
                      {{ ((item?.pricing[0]?.original_price - item?.pricing[0]?.price) /
                        item?.pricing[0]?.original_price *
                      100).toFixed(2) }} % Off
                    </span>
                  </span>

                  <span v-if="item?.pricing.length === 0" class="offer">
                    <span class="capitalize"
                      v-if="item?.schedules[0]?.price.original_price - item?.schedules[0]?.price.price !== 0 && !item?.schedules[0]?.price.is_free">
                      {{ ((item?.schedules[0]?.price.original_price - item?.schedules[0]?.price.price) /
                        item?.schedules[0]?.price.original_price *
                      100).toFixed(2) }} % Off
                    </span>
                  </span>

                  <span class="capitalize" v-if="item?.pricing[0]?.price.is_free">
                    {{ $t('free') }}
                  </span>

                    </div>
                  </div>
                </div>
              </router-link>

              <div class="px-10 pt-10 d-flex flex-column gap-2 courseCard-body">
                <h3 class="fw-700 text-dark-1 mt-15 capitalize">
                  {{ item?.title }}
                </h3>
                <div class="d-flex gap-3 teacher d-inline-flex align-items-center py-10 x-gap-5">
                  <span class="d-inline-block">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewbox="0 0 18 18" fill="none">
                      <path
                        d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                        stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round"></path>
                      <path
                        d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                        stroke="#94AD04" stroke-width="1.5"></path>
                    </svg>
                  </span>
                  <span class="fw-500 d-inline-block pt-1">
                    {{ item?.teacher.name }}
                  </span>
                </div>
                <!--- <p class="exprience fw-500">{{ item?.teacher.qualification }}</p> -->
                <div class="d-flex items-center mt-10">
                  <div class="d-flex x-gap-5 items-center">
                    <rating-component :rating="3"></rating-component>
                  </div>
                  <!----<div class="text-13 lh-1 ml-10 exprience">(1.2K)</div>-->
                </div>

                <!-----------Course Data------------------>
                <div class="d-flex flex-wrap  x-gap-10 y-gap-10 align-items-baseline pt-15 mt-1">
                  <div class="d-flex items-center gap-1">
                    <img class="mr-8" src="../../assets/images/icons/1.svg" alt="icon" />
                    <div class="text-14 lh-1">
                      {{ item?.options.chapter_count }} {{ $t('chapter_count') }}
                    </div>
                  </div>

                  <div class="d-flex items-center gap-1">
                    <img class="mr-8" src="../../assets/images/icons/3.svg" alt="icon" />
                    <div class="text-14 lh-1">{{ item?.options.lecture_count }} {{ $t('lecture_count') }}</div>
                  </div>

                  <div class="d-flex items-center gap-1">
                    <img class="mr-8" src="../../assets/images/icons/2.svg" alt="icon" />
                    <div class="text-14 lh-1"> {{ Math.ceil(item?.options.lecture_time_estimate_sec / 3600) }} {{
                      $t('hours') }} </div>
                  </div>

                </div>
                
                <!---Price Section-->
                <div>
                <div class="d-flex flex-column align-items-start pb-10 mt-5 pt-2 price"
                  v-if="item?.pricing.length !== 0">
                  <span class="pt-1"
                    :class="item?.pricing[0]?.original_price - item?.pricing[0]?.price !== 0 ? 'fw-700 price-orginial d-inline-block ' : 'd-none'">
                    {{ item?.pricing[0]?.price }}
                    {{ item?.pricing[0]?.currency }}
                  </span>

                  <span class="pt-1"
                    :class="item?.pricing[0]?.original_price - item?.pricing[0]?.price !== 0 ? 'fw-400 d-inline-block exprience line-through text-16' : 'fw-700 price-orginial '">
                    {{ item?.pricing[0]?.original_price }}
                    {{ item?.pricing[0]?.currency }}
                  </span>

                </div>

                <div class="d-flex flex-column align-items-start pb-10 mt-5 pt-2 price"
                  v-if="item?.pricing.length === 0">

                  <span class="pt-1"
                    :class="item?.schedules[0]?.price.original_price - item?.schedules[0]?.price.price !== 0 ? 'fw-700 price-orginial d-inline-block ' : 'd-none'">
                    {{ item?.schedules[0]?.price.price }}
                    {{ item?.schedules[0]?.price.currency }}
                  </span>

                  <span class="pt-1"
                    :class="item?.schedules[0]?.price.original_price - item?.schedules[0]?.price.price !== 0 ? 'fw-400 d-inline-block exprience line-through text-16' : 'fw-700 price-orginial '">
                    {{ item?.schedules[0]?.price.original_price }}
                    {{ item?.schedules[0]?.price.currency }}
                  </span>
                </div>
              </div>

                <div class="coursesCard-footer-1">
                  <router-link :to="{ name: 'single-course', params: { id: item.slug } }"
                    class="d-inline-flex justify-center align-items-center x-gap-10 main-button w-100">
                    {{ $t('detailsButtonText') }}
                  </router-link>
                </div>
              </div>
            </div>
            <!----end of course card---------->
            <!---- start of hover card -----------------
            <div class="side-content__item">
              <div class="px-30 pt-20 pb-30 rounded-8 border-light shadow-2 side-content__item-bg">
                <div class="text-18 lh-16 text-white">
                  {{ item?.title }}
                </div>

                <div class="row x-gap-10 y-gap-10 items-center pt-15">
                  <div class="col-auto">
                    <div class="d-flex items-center gap-2">
                      <img class="mr-8" src="../../assets/images/icons/1.svg" alt="icon" />
                      <div class="text-14 lh-1">
                        {{ item?.categories[0]?.label }}
                      </div>
                    </div>
                  </div>

                  <div class="col-auto">
                    <div class="d-flex items-center gap-2">
                      <img class="mr-8" src="../../assets/images/icons/2.svg" alt="icon" />
                      <div class="text-14 lh-1"> {{ item?.options['chapter_count'] }} Chapters </div>
                    </div>
                  </div>

                  <div class="col-auto">
                    <div class="d-flex items-center gap-2">
                      <img class="mr-8" src="../../assets/images/icons/3.svg" alt="icon" />
                      <div class="text-14 lh-1">{{ item?.options.language }}</div>
                    </div>
                  </div>
                </div>

                <div
                  class="d-inline-block px-15 py-5 bg-green-1 text-dark-1 rounded-200 text-11 fw-500 uppercase mt-20">
                  {{ item?.course_type }}
                </div>

                <p class="text-white mt-15" v-html="item.description ? item.description.substring(0, 200) : ''"></p>

                <div class="row y-gap-15 pt-15">
                  <div class="col-12" v-for="(goal, i) in item?.what_learn" :key="i">
                    <div class="d-flex items-center">
                      <div class="size-20 d-flex items-center justify-center rounded-full border-light">
                        <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                          <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M5 11.917 9.724 16.5 19 7.5" />
                        </svg>
                      </div>
                      <div class="ml-10">
                        {{ goal > 50 ? goal.substring(1, 30) + "..." : goal }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            ------ End Of hover card --------------->
          </div>
        </div>
        <!------end of courses list------------>
        <!--- end of courses list----------->
      </section>
    </div>
  </section>
</template>
<script>
//import { mapGetters } from "vuex";
import RatingComponent from "../common/RatingComponent.vue";
//import Loader from "../common/Loader.vue";
//import store from "@/store";
//import { getBundleContent } from "@/Services/api/BundlesService";
export default {
  props: {
    courses: {
      type: Array
    }
  },
  components: {
    RatingComponent,
    // Loader
  },
  data() {
    return {
      // courses: [],
      // loading: false,
      // title: '',
      // description : '',
      // cover : '',
      // purchaseLink : ''
    };
  },
  computed: {
    // Calculate total pages
    // ...mapGetters(["currentLanguage"]),
    // isAuthenticated() {
    //   return store.getters.isAuthenticated
    // },
    // bundleId() {
    //   return this.$route.params.id;
    // },
    // filterCriteria() {
    //   return {
    //     language: this.currentLanguage,
    //     bundle: this.bundleId,
    //   };
    // }
  },
  methods: {
    //get Bundle Content
    // async getBundleContent() {
    //   try {
    //     this.loading = true;
    //     const response = await getBundleContent(this.bundleId);
    //     this.courses = response.data.courses
    //     this.title = response.data.title
    //     this.description = response.data.description
    //     this.cover = response.data.cover
    //     this.purchaseLink = response.data.purchase_link
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     this.loading = false;
    //   }
    // }
  },
  // watch: {
  //   filterCriteria: {
  //     handler(newCriteria, oldCriteria) {
  //       this.getBundleContent()
  //     },
  //     immediate: true, // Run the handler immediately when the component is mounted
  //   },
  // },
};
</script>

<style lang="scss" scoped>
.heading {
  font-size: 2.5rem;
  font-weight: bold;
  background: linear-gradient(90deg, #4CAF50, #2196F3);
  -webkit-background-clip: text;
  color: transparent;
  animation: fadeIn 1.2s ease-in-out;
}

.subheading {
  font-size: 1.2rem;
  color: #555;
  margin-top: 5px;
  opacity: 0.8;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>